import { render, staticRenderFns } from "./LogoPrimary.vue?vue&type=template&id=1a1ed428&scoped=true&"
import script from "./LogoPrimary.vue?vue&type=script&lang=js&"
export * from "./LogoPrimary.vue?vue&type=script&lang=js&"
import style0 from "./LogoPrimary.vue?vue&type=style&index=0&id=1a1ed428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ed428",
  null
  
)

export default component.exports